import React from 'react';
// import './Dashboard.css'; // Styles might now primarily come from AppLayout and Tailwind
import AppLayout from '../layout/AppLayout'; // Import the new layout
import { SidebarProvider } from '../context/SidebarContext'; // Import the provider
import { Routes, Route, Navigate } from 'react-router-dom'; // Added Outlet and Navigate
import { AgentsPage } from './dashboard/AgentsPage'
import { SettingsPage } from './dashboard/SettingsPage'
import WorkflowsPage from './dashboard/WorkflowsPage';

// Import the new page components
import StatisticsPage from './dashboard/StatisticsPage';
// import AgentsPage from './dashboard/AgentsPage'; // Removed import
import CallsPage from './dashboard/CallsPage';
import KnowledgeBasePage from './dashboard/KnowledgeBasePage';
import BillingPage from './dashboard/BillingPage';
import AuditsPage from './dashboard/AuditsPage';
import AuditDetailsPage from './dashboard/AuditDetailsPage';

const Dashboard = () => {
  return (
    <SidebarProvider> { /* Wrap with SidebarProvider */}
      <AppLayout>
        <Routes>
          <Route path="/" element={<Navigate to="calls" replace />} />
          <Route path="calls" element={<CallsPage />} />
          <Route path="statistics" element={<StatisticsPage />} />
          <Route path="agents" element={<AgentsPage />} />
          <Route path="workflows" element={<WorkflowsPage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="knowledge-base" element={<KnowledgeBasePage />} />
          <Route path="audits" element={<AuditsPage />} />
          <Route path="audits/:auditId" element={<AuditDetailsPage />} />
        </Routes>
      </AppLayout>
    </SidebarProvider>
  );
};

// This is a new component that will define the routes within the dashboard layout
export const DashboardRoutes = () => {
  return <Dashboard />
}

// export default Dashboard; // We will export DashboardRoutes from App.jsx instead 